import styled from 'styled-components';

import { pxToRem } from '../../lib/utils';

export const StyledWrapper = styled.div`
  display: flex;
  min-height: 100%;
  flex-direction: column;
  background-color: ${({ hasLightBg, theme }) => (hasLightBg ? theme.colors.b : theme.colors.c)};
  justify-content: space-between;
`;

export const StyledErrorBox = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  margin: auto;
  padding: 0 ${pxToRem(20)};
`;

export const StyledHeading = styled.h2`
  margin: 0;
  color: ${({ theme }) => theme.colors.e};
  font-family: ${({ theme }) => theme.fonts.headings};
  font-weight: 700;
  font-size: ${pxToRem(28)};
  line-height: ${pxToRem(36)};
`;

export const StyledText = styled.p`
  margin: ${pxToRem(16)} 0 ${pxToRem(30)} 0;
  color: ${({ theme }) => theme.colors.e};
  font-size: ${pxToRem(15)};
  line-height: ${pxToRem(21)};
  text-align: center;
`;
